<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/12.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">AI智能车载</h3>
            <p class="title-details">
              车载监控前后端产品，搭载使用雄迈车载监控云平台-蜂云，为用户提高车辆行驶安全。可以实时记录车辆定位信息，车辆行驶录像，车辆行驶轨迹等。方便司机查看周围环境，远程查看，事件回溯，提高事故救援效率。
            </p>
            <!-- <van-button
              v-show="showVideo"
              round
              class="title-box-bottom-video"
              @click="
                () => {
                  this.$router.push({
                    name: 'video',
                    query: {
                      src:
                        'static/video/AIintelligentautonomouspackagesolution.mp4'
                    }
                  });
                }
              "
            >
              <van-icon :name="require('../assets/images/play.png')" />
              <span>AI智能自主套包解决方案</span>
            </van-button> -->
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active" swipeable animated>
          <van-tab
            v-for="item in messageList"
            :key="item.id"
            :title="item.title"
          >
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link
                      :to="{ path: list.url, query: { src: list.src } }"
                    >
                      <van-button
                        class="title-box-bottom-video change-color"
                        round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" fit="contain" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details"
                      >{{ article.articledetails }}
                    </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,

      messageList: [
        {
          id: 1,
          title: "AI智能车载",
          details: "",
          buttonList: [],
          articleList: [
            {
              id: 1 - 1 - 1,
              src: require("../assets/images/newAdd/42.jpg"),
              articletitle: "AI智能车载",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "4*1080P高清车载监控"
                    },
                    {
                      light: "监控无死角，防碰瓷，防刮擦"
                    },
                    {
                      light: "支持H.265AI编码，低码流，低存储"
                    },
                    {
                      light: "帧累积技术，降低噪点，提高亮度，夜视效果成倍增强"
                    },
                    {
                      light: "本地硬盘存储+云存储"
                    },
                    {
                      light: "支持Gsensor，GPS定位，国内外4G网络"
                    },
                    {
                      light:
                        "支持倒车测距辅助，延迟关机，断电保护，超速报警，侧翻急刹报警"
                    }
                  ]
                }
              ],
              have: false,
              href: ""
            }
          ]
        }
      ]
    };
  },
  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    }
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  }
};
</script>

<style></style>
